import { JobPhaseReceivableSheetList } from './views';

export default {
  list: JobPhaseReceivableSheetList,
  name: 'job-phase-receivable-sheet',
  label: 'Production - Receivables',
  to: '/job-phase-receivable-sheet',
};
